module.exports = __webpack_public_path__ + "static/media/2-iphone-left.3d594b58.png";